<div *ngIf="items.length > 0" class="metricsLine" [class.large]="large">
    <fe-icon *ngIf="showIcon" [iconType]="IconType.donnees_chiffrees" matTooltip="Données chiffrées" matTooltipPosition="after" class="lineIcon"/>
    <span *ngFor="let item of visibleItems" class="metricChip">{{item.label}} : <b>{{item.value}}</b></span>
    <span *ngIf="hiddenCount > 0" class="metricChip metricMore" matTooltipClass="multiline-tooltip"
          [matTooltip]="hiddenTooltip">+{{hiddenCount}}</span>
</div>
